<script setup lang="ts">
/**
 * 源站 .FloatingBall_qipao2 / .qipao3.new_sign_rewards 1:1。
 * 文案固定 Recibe {n} Bonos；黄底 #fcc141；gift + shake-scale。
 * 390 宽量得 px ÷ 19.5 → oro rem（22.5@450）。
 */
import { computed, onMounted } from 'vue';
import { oroMxAssetPaths } from '@/shared/theme/oro-mx-home-data';
import { formatOroMxAmount } from '@/shared/theme/oro-mx-money';
import { useSiteProfileStore } from '@/stores/site-profile-store';

const props = withDefaults(
  defineProps<{
    variant?: 'header' | 'submit';
  }>(),
  { variant: 'header' },
);

const siteProfile = useSiteProfileStore();
const amountLabel = computed(() => formatOroMxAmount(siteProfile.registerPointsMinor));
const rootClass = computed(() =>
  props.variant === 'submit' ? 'FloatingBall_qipao2' : 'FloatingBall_qipao3',
);

onMounted(() => {
  void siteProfile.load();
});
</script>

<template>
  <div
    v-if="siteProfile.showRegisterGift"
    class="new_sign_rewards"
    :class="rootClass"
    aria-hidden="true"
  >
    <div class="text">
      <div class="sp1">
        <div class="ic">
          <img :src="oroMxAssetPaths.authSignupGift" alt="" />
        </div>
        <div class="spp">
          Recibe <span class="sp12">{{ amountLabel }}</span> Bonos
        </div>
      </div>
      <div class="ic_image">
        <div class="sp2" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.new_sign_rewards {
  display: flex;
  overflow: visible;
  box-sizing: border-box;
  font-family:
    -apple-system, system-ui, 'Helvetica Neue', Helvetica, 'Segoe UI', Arial, Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft Yahei', sans-serif;
  pointer-events: none;
}

.FloatingBall_qipao3 {
  position: absolute;
  top: 1.959rem;
  right: 0;
  left: 0;
  z-index: 4;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 1.0665rem;
  color: #98a7b5;
  font-size: 0.7179rem;
  font-weight: 400;
  line-height: 0.7179rem;
}

.FloatingBall_qipao2 {
  position: absolute;
  top: -0.9231rem;
  right: 0;
  left: 0;
  z-index: 1;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  min-width: 100%;
  max-width: 200%;
  height: 1.1731rem;
  padding: 0 1.0256rem 0 0;
  color: #fff;
  font-size: 0.8205rem;
  font-weight: 600;
  line-height: 0.8205rem;
}

.FloatingBall_qipao3 .text {
  position: relative;
  display: block;
  width: max-content;
  height: 1.0665rem;
  padding: 0 0.0533rem;
  color: #98a7b5;
  font-size: 0.7179rem;
  font-weight: 400;
  line-height: 0.7179rem;
  background: #fcc141;
  border-radius: 1.5385rem;
}

.FloatingBall_qipao2 .text {
  position: relative;
  display: block;
  width: max-content;
  height: 1.1731rem;
  color: #fff;
  font-size: 0.8205rem;
  font-weight: 600;
  line-height: 0.8205rem;
  background: #fcc141;
  border-radius: 0.2564rem;
}

.sp1 {
  position: relative;
  z-index: 3;
  display: flex;
  overflow: visible;
  align-items: center;
  box-sizing: border-box;
  height: 100%;
  padding: 0.0533rem 0.1067rem;
  color: #000;
  white-space: nowrap;
}

.FloatingBall_qipao3 .sp1 {
  left: -0.1333rem;
  font-size: 0.64rem;
  font-weight: 400;
  line-height: 0.64rem;
  background: #fcc141;
  border-radius: 1.5385rem;
}

.FloatingBall_qipao2 .sp1 {
  left: -0.2564rem;
  font-size: 0.6933rem;
  font-weight: 600;
  line-height: 0.6933rem;
  border-radius: 0.2564rem;
}

.ic {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  transform-origin: 50% 100%;
  animation: shake-scale 2s infinite;
}

.FloatingBall_qipao3 .ic,
.FloatingBall_qipao3 .ic img {
  width: 1.3758rem;
  height: 0.96rem;
}

.FloatingBall_qipao2 .ic,
.FloatingBall_qipao2 .ic img {
  width: 1.5284rem;
  height: 1.0665rem;
}

.ic img {
  display: block;
  object-fit: contain;
}

.spp {
  color: #000;
  font-weight: 400;
  white-space: nowrap;
}

.FloatingBall_qipao3 .spp {
  font-size: 0.64rem;
  line-height: 0.64rem;
}

.FloatingBall_qipao2 .spp {
  font-size: 0.6933rem;
  line-height: 0.6933rem;
}

.sp12 {
  color: #000;
  font-weight: 700;
}

.ic_image {
  position: absolute;
  right: 0;
  left: 0;
  display: flex;
  overflow: visible;
  height: 0;
}

.FloatingBall_qipao3 .ic_image {
  top: 0;
  justify-content: center;
}

.FloatingBall_qipao2 .ic_image {
  top: 1.1731rem;
  justify-content: flex-start;
}

.sp2 {
  position: absolute;
  z-index: 1;
  display: block;
  width: 0.5128rem;
  height: 0.5128rem;
  background: #fcc141;
  transform: rotate(45deg);
}

.FloatingBall_qipao3 .sp2 {
  top: -0.2564rem;
}

.FloatingBall_qipao2 .sp2 {
  top: -0.359rem;
  left: 0.4615rem;
}

@keyframes shake-scale {
  0%,
  70%,
  100% {
    transform: rotate(0deg) scale(1);
  }

  75% {
    transform: rotate(4deg) scale(1.05);
  }

  80% {
    transform: rotate(-4deg) scale(1.05);
  }

  85% {
    transform: rotate(3deg) scale(1.05);
  }

  90% {
    transform: rotate(-3deg) scale(1.05);
  }

  95% {
    transform: rotate(1deg) scale(1.05);
  }
}
</style>
